module.exports = __webpack_public_path__ + "img/border_garden.bd7e24e8.svg";